import { createApp } from '@wu/widget-core';
import { Accessibility } from './accessibility';
import { meta } from './meta';

export default createApp(
  { alias: meta.appAlias, name: meta.appName },
  Accessibility
);
